import { useState } from "react";

export const useAgreement = () => {
  const [agree, setAgree] = useState<boolean>(false);
  const [isOpenAgreementModal, setIsOpenAgreementModal] =
    useState<boolean>(false);

  const handleOpenAgreementModal = () => {
    setIsOpenAgreementModal(true);
  };
  const handleCloseIsOpenAgreementModal = () => {
    setIsOpenAgreementModal(false);
  };

  const handleCheckAgreement = () => {
    if (!agree) setAgree(true);
    setIsOpenAgreementModal(false);
  };

  const handleChangeAgreement = () => {
    setAgree((prev) => !prev);
  };

  return {
    agree,
    isOpenAgreementModal,
    handleCheckAgreement,
    handleOpenAgreementModal,
    handleCloseIsOpenAgreementModal,
    handleChangeAgreement,
  };
};
